import * as React from "react";
const SvgGemini = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 30, height: 30, rx: 15, fill: "white" }),
  /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 30, height: 30, rx: 15, stroke: "white", strokeWidth: 2 }),
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_12443_52743)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M27.2 16.0224C24.2939 16.2007 21.5533 17.4356 19.4945 19.4944C17.4357 21.5532 16.2008 24.2939 16.0224 27.2H15.9776C15.7996 24.2938 14.5648 21.553 12.5059 19.4941C10.4471 17.4352 7.70628 16.2004 4.80005 16.0224L4.80005 15.9776C7.70628 15.7995 10.4471 14.5647 12.5059 12.5059C14.5648 10.447 15.7996 7.70622 15.9776 4.79999L16.0224 4.79999C16.2008 7.70612 17.4357 10.4467 19.4945 12.5055C21.5533 14.5644 24.2939 15.7992 27.2 15.9776V16.0224Z",
      fill: "url(#paint0_radial_12443_52743)"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint0_radial_12443_52743",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(7.02325 13.9042) rotate(18.6832) scale(23.842 190.989)"
    },
    /* @__PURE__ */ React.createElement("stop", { offset: 0.067, stopColor: "#9168C0" }),
    /* @__PURE__ */ React.createElement("stop", { offset: 0.343, stopColor: "#5684D1" }),
    /* @__PURE__ */ React.createElement("stop", { offset: 0.672, stopColor: "#1BA1E3" })
  ), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_12443_52743" }, /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: 22.4,
      height: 22.4,
      fill: "white",
      transform: "translate(4.80005 4.79999)"
    }
  )))
);
export default SvgGemini;
